"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _algoliasearch = _interopRequireDefault(require("algoliasearch"));

var Search = function Search(appId, apiKey) {
  var _this = this;

  (0, _classCallCheck2["default"])(this, Search);
  (0, _defineProperty2["default"])(this, "client", void 0);
  (0, _defineProperty2["default"])(this, "requestIndex", function (_ref) {
    var index = _ref.index,
        query = _ref.query,
        searchOptions = _ref.searchOptions;

    var clientIndex = _this.client.initIndex(index);

    return clientIndex.search(query, searchOptions);
  });
  (0, _defineProperty2["default"])(this, "requestMultipeIndexes", function (multipleQueries) {
    return _this.client.multipleQueries(multipleQueries);
  });
  (0, _defineProperty2["default"])(this, "requestFacetValues", function (_ref2) {
    var index = _ref2.index,
        facet = _ref2.facet,
        query = _ref2.query;

    var clientIndex = _this.client.initIndex(index);

    return clientIndex.searchForFacetValues(facet, query);
  });
  this.client = (0, _algoliasearch["default"])(appId, apiKey);
};

var _default = Search;
exports["default"] = _default;
//# sourceMappingURL=search.js.map